<!-- <p>visor-video works!</p> -->
<div class="video">
    <video style="width: 100%; height: 100%;" controls (click)="toggleVideo($event)" (play)="videoPlay()" (pause)="videoPause()" #videoPlayer >
        <source src="{{videoSource}}" type="video/mp4" />
        Browser not supported
    </video>

	<!-- <button (click)="skip(-10)">Rewind</button>
    <button (click)="skip(10)">Fastforward</button> -->
    
    <!-- <div id="status" class="incomplete">
        <span>Play status: </span>
        <span class="status complete">COMPLETE</span>
        <span class="status incomplete">INCOMPLETE</span>
        <br />
    </div>
    <div>
        <span id="played">0</span> seconds out of
        <span id="duration"></span> seconds. (only updates when the video pauses)
    </div> -->
  <!-- Video Controls -->



</div>



<!-- <video width="480" height="400" controls="true" poster="" id="video">
    <source type="video/mp4" src="http://www.w3schools.com/html/mov_bbb.mp4"></source>
</video> -->